/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --nve-sys-interaction-background: var(--nve-sys-interaction-background-300);
  --nve-sys-interaction-field-background: var(--nve-sys-interaction-background-300);
  --nve-sys-layer-popover-arrow-padding: 6px;
  --nve-sys-layer-popover-arrow-offset: 4px;
  --nve-sys-layer-popover-offset: var(--nve-ref-space-xxl);
  --border: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
  --border-radius: var(--nve-ref-border-radius-lg);
  --background: var(--nve-sys-layer-overlay-background);
  --color: var(--nve-sys-layer-overlay-color);
  --padding: var(--nve-ref-size-300) var(--nve-ref-size-400);
  --box-shadow: var(--nve-ref-shadow-500);
  --gap: var(--nve-ref-space-sm);
  --max-width: 600px;
  --min-height: 250px;
  --max-height: 100vh;
  width: 100vw;
  height: min-content;
  max-width: var(--max-width);
  max-height: var(--max-height);
  min-height: var(--min-height);
}

:host([size='sm']) {
  --max-width: 400px;
}

:host([size='lg']) {
  --max-width: 840px;
}

[internal-host] {
  border-radius: var(--border-radius);
  border: var(--border);
  background: var(--background);
  color: var(--color);
  box-shadow: var(--box-shadow);
  padding: var(--padding);
  max-height: var(--max-height);
  height: inherit;
  width: inherit;
  max-width: inherit;
  min-height: inherit;
  min-width: inherit;
}

:host([modal])::backdrop {
  /* --nve-sys-layer-backdrop-background (not available on top layer) */
  background: hsl(0 0% 0% / 0.5); /* eslint-disable-line @nvidia-elements/lint/no-unexpected-css-value */
}

.header {
  display: flex;
  gap: var(--gap);
}

.content {
  overflow: auto;
  min-height: inherit;
  scrollbar-color: var(--nve-sys-scrollbar-thumb-color) var(--nve-sys-scrollbar-track-color);
  scrollbar-width: var(--nve-sys-scrollbar-width);

  slot {
    gap: var(--gap);
    min-height: inherit;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
}

nve-icon-button {
  position: absolute;
  top: var(--nve-ref-size-200);
  right: var(--nve-ref-size-200);
  z-index: 99;
}
